import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { IDropDownView } from "../interfaces/idropdowns";
import { DropDownsService } from "../services/dropdowns.service";

@Injectable()
export class DropDownResolver implements Resolve<IDropDownView> {
    constructor(private dropDownsService : DropDownsService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IDropDownView> {
        let id: number = route.params["dropDownId"] != null ? route.params["dropDownId"] : route.params["id"];
        return this.dropDownsService.getDropDown(id);
    }
}

